<template>
   <div>
       <span>{{customerSignaturesCreated}}</span>
       <a v-if="canSeeCustomerSignatures" href="#" @click="initMapModal($event)"  aria-hidden="true" data-toggle="modal" :data-target="`#mapModal`"><span style="font-size: 14px; font-weight: 600;"> View </span></a>
       <div v-if="showMapPopup" class="modal  confirmation-popup" tabindex="-1" role="dialog" :id="`mapModal`">
           <div class="modal-dialog confirmation-popup-width" role="document">
               <div class="modal-content">
                   <div class="modal-header new-design">
                       <h5 class="modal-title d-inline"> Signature </h5>
                       <svg class="close-icon clickable" data-dismiss="modal" aria-label="Close" width="24" height="24"
                            viewBox="0 0 24 24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                           <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 10.59L15.59 7L17 8.41L13.41 12L17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59Z" fill="#2E4051"/>
                       </svg>
                   </div>
                   <div class="modal-body">
                      <img :src="signatureLink"  style="width: 100%">
                   </div>
                   <div class="modal-footer new-design" style="padding: 10px 0px">
                       <div class="col-md-12 col-xs-12 row" style="padding: 0px">
                          <div class="col-md-6  col-xs-6"></div>
                          <div class="col-md-6 col-xs-6 text-right" style="padding: 0px">
                              <a v-if="signatureLink && canRemoveCustomerSignatures"
                                 target="_blank"
                                 @click="confirmDelete"
                                 class="btn btn-danger" style="margin-top: -4px;">
                                  Remove Signature
                              </a>
                          </div>
                       </div>
                   </div>
               </div>
           </div>
       </div>

   </div>
</template>

<script>
import {EventBus} from "@/events/event-bus";
import {deleteCustomerSignatureAction} from '@/modules/common/api'
export default {
    name: "signedOn",
    props: {
        customerSignaturesId:null,
        signatureLink:null,
        customerSignaturesCreated:null,
        showMapPopup:false,
        canSeeCustomerSignatures:0,
        canRemoveCustomerSignatures:0,
    },
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {
        confirmDelete(){
            deleteCustomerSignatureAction(this.customerSignaturesId).then((response) => {
                $.notify(response.data.message, response.data.type);
                $('#mapModal').modal('toggle');
                EventBus.$emit('signatureRemoved');
            })

        },
        initMapModal(event){
            event.preventDefault();
            this.showMapPopup = true;
            setTimeout(this.mapResize, 200);
        },
    },
    watch: {

    }
}
</script>
<style scoped>
modal-header.new-design {
    border-bottom: unset;
}

.has-error .form-control {
    border-color: #a94442 !important;
}

.modal-header.new-design .modal-title {
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 24px;
    color: #2E4051;
    display: inline;
}

.modal-footer.new-design {
    border-top: unset;
    text-align: left;
    padding-top: 0px;
}

.close-icon {
    float: right;
}

.clickable {
    cursor: pointer;
}

.error-label {
    top: 8px;
    position: relative;
}

.btn.new-design {
    border-radius: 8px;
    padding: 12px 16px;
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    text-align: center;
    color: #FFFFFF;
}

.btn-primary.new-design {
    background: #2E4051 !important;
    float: right;
}
.btn-default.new-design{
    color: #2E4051
}

.form-control.new-design::placeholder {
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
}

.form-control.new-design {
    padding: 16px;
    border: 1px solid #E0E2E5;
    border-radius: 8px;
    box-sizing: border-box;

    height: 56px;

    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
}

.btn.new-design {
    margin-bottom: unset;
}
@media (max-width: 768px) {
    .btn.new-design {
        width: 100%
    }
    .btn-default.new-design{
        margin-bottom: 10px;
    }
}
</style>

